import React, { useState } from 'react'

import ExpandedPaymentScheduleRow from './ExpandedPaymentScheduleRow'
import { ReactComponent as RightCarat } from '../../assets/rightCarat.svg'
import { ReactComponent as DownCarat } from '../../assets/downCarat.svg'

import './PaymentBuilder.css'

export default function ExpandedPaymentSchedule({
	year,
	expandPaymentDetails,
	payments,
}) {
	const [expandPayments, setExpandPayments] = useState(true)

	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	let total = 0

	payments.forEach((payment) => (total += payment.amount))

	return (
		<>
			<div className='annual-total'>
				<div
					className='expand-year hover'
					onClick={() => setExpandPayments(!expandPayments)}
				>
					{(expandPayments && expandPaymentDetails) || expandPayments ? (
						<DownCarat />
					) : (
						<RightCarat />
					)}
					<span className='padding-left'>{year}</span>
				</div>
				<div>
					<b>{formatter.format(total)}</b>
				</div>
			</div>
			{(expandPayments && expandPaymentDetails) || expandPayments ? (
				<div className='expanded-payment-container'>
					{payments.map((row, index) => {
						return (
							<ExpandedPaymentScheduleRow
								date={row.formattedDate}
								amount={row.amount}
								key={index}
								id={index}
							/>
						)
					})}
				</div>
			) : null}
		</>
	)
}
